module.exports = __webpack_public_path__ + "assets/chartjs.ed2f373e.svg";